<template>
  <!-- <div class="min-height-300 position-absolute w-100 bg-gradient-info"/> -->
  <div class="min-height-300 position-absolute w-100" style="background-color: #0083DF;"/>
  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl fixed-start ms-3 bg-white"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <router-link  class="m-0 navbar-brand" to="/">
        <img
        style="max-height: 4rem !important;"
          src="../../assets/images/loginimagen.png"
          class="navbar-brand-img h-100"
          alt="main_logo"
        />
        <!-- <span class="ms-2 font-weight-bold me-2">EASYTURNO</span> -->
      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logooficial.png";

export default {
  name: "index",
  components: {
    SidenavList
  },
  data() {
    return {
      logo,
    };
  },
};
</script>
